import * as Styles from './styles'

type IlustrationBoxProps = {
  score: number
  isInitial: boolean
  background: string
  scoreText?: string
}

export const IlustrationBox = ({
  score,
  isInitial,
  background,
  scoreText,
}: IlustrationBoxProps) => {
  return (
    <Styles.IlustrationContainer>
      <Styles.ImageContainer>
        <Styles.Image $isNoResume={isInitial} />
      </Styles.ImageContainer>
      {!!score && (
        <Styles.ScoreContainer>
          <Styles.Score $background={background}>{score}%</Styles.Score>
          <Styles.ScoreText>{scoreText}</Styles.ScoreText>
        </Styles.ScoreContainer>
      )}
    </Styles.IlustrationContainer>
  )
}
